(function () {
  'use strict';

  const gsap = window.gsap;
  const { easePower4 } = window.Universe;

  class Accordions {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.elements.length; i++) {
        this.instances.push(new Accordion(this.DOM.elements[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      if (sectionEl.querySelector('.js-accordion')) {
        this.reinit();
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const elements = container.querySelectorAll('.js-accordion');

      if (elements.length) {
        this.DOM = {};
        this.DOM.elements = elements;
        this.instances = [];
        this.setup();
      }
    }
  }

  class Accordion {
    constructor(element) {
      if (!element) return;
      this.init(element);
    }

    setup() {
      this._toggle = () => { this.toggle(); };
      this.DOM.head.addEventListener('click', this._toggle);

      if (this.DOM.element.dataset.open !== undefined) {
        this.open(true);
      }
    }

    toggle() {
      const isActive = this.DOM.element.classList.toggle('is-active');
      this.DOM.head.setAttribute('aria-expanded', isActive.toString());

      gsap.to(this.DOM.body, {
        height: isActive ? 'auto' : 0,
        duration: 0.6,
        ease: easePower4,
      });
    }

    open(immediate = false) {
      this.DOM.element.classList.add('is-active');
      this.DOM.head.setAttribute('aria-expanded', 'true');

      gsap.to(this.DOM.body, {
        height: 'auto',
        duration: immediate ? 0 : 0.6,
        ease: easePower4,
      });
    }

    destroy() {
      if (this.DOM) {
        this.DOM.head.removeEventListener('click', this._toggle);
        this.DOM = undefined;
      }
    }

    init(element) {
      this.DOM = {};
      this.DOM.element = element;
      this.DOM.head = this.DOM.element.querySelector('.js-accordion-head');
      this.DOM.body = this.DOM.element.querySelector('.js-accordion-body');

      this.setup();
    }
  }

  window.Universe = window.Universe || {};
  window.Universe.Accordions = Accordions;
  window.Universe.Accordion = Accordion;
})();
